import { create } from 'zustand'

const PENDING_BOOKING_KEY = "qetero.pendingBooking"

interface BranchItem {
  id: string
  name: string
  subtitle?: string
  badge?: "VIP" | "NEW"
}

interface ServiceItem {
  id: string
  name: string
  description?: string
  price?: number
  duration?: number
}

interface BookingState {
  selectedBranch: BranchItem | null
  selectedService: ServiceItem | null
  selectedDate: string | null
  selectedSlot: any | null
  lastSlotSelectionTime?: number
  bookingType: "self" | "other"
  mode: "booking" | "reschedule"
  appointmentId: string | null // For reschedule
  calendarType: "GC" | "EC" // Calendar type: Gregorian or Ethiopian
  bookingStep: "branch" | "service" | "schedule" | "mode" // Current wizard step
  scheduleEntrySource?: "wizard" | "map" // Where the user came from when landing on schedule step

  setBookingState: (state: Partial<BookingState>) => void
  resetBookingState: () => void
}

export const useBookingStore = create<BookingState>((set) => ({
  selectedBranch: null,
  selectedService: null,
  selectedDate: null,
  selectedSlot: null,
  bookingType: "self",
  mode: "booking",
  appointmentId: null,
  calendarType: "GC",
  bookingStep: "branch",

  setBookingState: (state) => set((prev) => ({ ...prev, ...state })),
  resetBookingState: () => set({
    selectedBranch: null,
    selectedService: null,
    selectedDate: null,
    selectedSlot: null,
    bookingType: "self",
    mode: "booking",
    appointmentId: null,
    calendarType: "GC",
    bookingStep: "branch",
    scheduleEntrySource: undefined,
  }),
}))

export type PendingBooking = {
  selectedBranch: BranchItem
  mode?: BookingState["mode"]
  appointmentId?: string | null
  bookingType?: BookingState["bookingType"]
}

export function savePendingBooking(data: PendingBooking): void {
  if (typeof window === "undefined") return
  window.sessionStorage.setItem(PENDING_BOOKING_KEY, JSON.stringify(data))
}

export function readPendingBooking(): PendingBooking | null {
  if (typeof window === "undefined") return null
  try {
    const raw = window.sessionStorage.getItem(PENDING_BOOKING_KEY)
    if (!raw) return null
    const data = JSON.parse(raw) as PendingBooking
    if (!data?.selectedBranch) return null
    return data
  } catch {
    return null
  }
}

export function clearPendingBooking(): void {
  if (typeof window === "undefined") return
  window.sessionStorage.removeItem(PENDING_BOOKING_KEY)
}
